import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress, Typography } from '@mui/material';
import { Api } from 'apis';

function OAuthCallback({ provider }: { provider: string }) {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const code = searchParams.get('code');

	useEffect(() => {
		if (!code || !provider) {
			navigate('/');
			return;
		}

		const endpointMap: Record<string, string> = {
			jobadder: '/api/exchange-oauth-code-jobadder/',
			bullhorn: '/api/exchange-oauth-code-bullhorn/',
			vincere: '/api/exchange-oauth-code-vincere/',
		};

		const endpoint = endpointMap[provider];

		if (!endpoint) {
			console.error('Invalid provider:', provider);
			navigate('/');
			return;
		}

		Api.post(endpoint, { code })
			.then(() => {
				console.log(`${provider} OAuth exchange successful`);

				// Set OAuth completion flag for candidate form to detect
				localStorage.setItem('oauth_completed', 'true');

				// Navigate to success page
				navigate(`/oauth-${provider}-success`);
			})
			.catch(err => {
				console.error(`${provider} OAuth exchange failed`, err);
				navigate('/');
			});
	}, [code, provider, navigate]);

	return (
		<div className='flex h-screen flex-col items-center justify-center bg-gray-50 px-4 text-center'>
			<CircularProgress
				color='secondary'
				size={48}
				thickness={4}
			/>
			<Typography
				variant='h6'
				className='mt-4 text-gray-600'
			>
				Completing{' '}
				{provider && provider?.charAt(0).toUpperCase() + provider?.slice(1)}{' '}
				Integration...
			</Typography>
		</div>
	);
}

export default OAuthCallback;
